import { useI18n } from '../../../../shared/i18n/useI18n';

import { formatProductPrice } from '../../../../shared/utils';

import { OfferBadge } from '../../../../shared/ui/OfferBadge/OfferBadge';

import styles from './ProductList.module.scss';

export function ProductPriceCell({ product, context }) {
  const { t } = useI18n();
	const { displayPrice, isHidden, isOnOffer, strikethroughPrice } =
		formatProductPrice(product, {
			...context.pricesVisibility
		});
	if (isHidden)
		return (
			<em className={styles.priceHidden}>{t('catalog.price_hidden')}</em>
		); //TODO centralize price formatting for hidden and null/falsy values
	return (
		<span className={styles.priceCell}>
			{isOnOffer && (
				<span className={styles.priceCellItem}>
					<OfferBadge size="tiny" />
				</span>
			)}
			<span className={styles.priceCellItem}>
				{isOnOffer && strikethroughPrice && (
					<s className={styles.strikethroughPrice}>{strikethroughPrice}</s>
				)}
				<span className={isOnOffer ? styles.offerPrice : ''}>
					{displayPrice ?? '—'}{' '}
					{/*//TODO centralize price formatting for hidden and null/falsy values*/}
				</span>
			</span>
		</span>
	);
}
